'use client';
import SwiperThumbs from '@/components/Gallery/SwiperThumbs';
import NextImage from '@/components/Image/NextImage';
import { ProductSheetType } from '@/components/data/dataType';
import Prose from '@/components/shopping/prose';

const ProductSheet: React.FC<{
    product: ProductSheetType;
    locale: string;
}> = ({ product, locale }) => {
    return (
        <div className="bg-white">
            <div className="mx-auto w-full max-w-[100vw] sm:max-w-[640px] md:max-w-[768px] lg:max-w-none px-2 py-16 sm:px-6 sm:py-24 lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8">
                    <div className="flex flex-col-reverse">
                        {product?.images && product?.images?.length < 2 ? (
                            <div className="aspect-h-1 aspect-w-1 w-full">
                                <NextImage
                                    alt={
                                        product.title[locale] ||
                                        product?.images[0].name
                                    }
                                    className="mx-auto block w-full h-full"
                                    image={product?.images[0]}
                                    style={{
                                        objectFit: 'contain',
                                        maxHeight: `${400}px`,
                                    }}
                                />{' '}
                            </div>
                        ) : (
                            <SwiperThumbs
                                data={product?.images.map((image, i) => ({
                                    id: i.toString(),
                                    image: image,
                                }))}
                                imageClass="max-h-[350px] mx-auto block w-full max-w-full object-cover"
                                imageSource="supabase"
                                imgStyle={{
                                    maxHeight: '350px',
                                    objectFit: 'contain',
                                }}
                                locale={locale}
                                onSlideChanged={() => {}}
                            />
                        )}
                    </div>

                    <div className="mt-10 px-0 sm:mt-16 lg:mt-0">
                        <h1 className="text-3xl font-bold tracking-tight text-gray-900">
                            {product?.title || ''}
                        </h1>
                        <Prose
                            className="text-base leading-tight text-gray-800"
                            html={product.subtitle[locale]}
                        />
                        {(product?.price || 0) !== 0 && (
                            <div className="mt-3">
                                <p className="text-3xl tracking-tight text-gray-900">
                                    {product?.price}
                                </p>
                            </div>
                        )}

                        <div className="mt-6">
                            <h3 className="sr-only">Description</h3>
                            <Prose
                                className="text-base text-gray-700"
                                html={product.description[locale]}
                            />
                            <div className="divide-y divide-gray-200 border-t mt-10">
                                <div className="mt-6">
                                    <div className="bg-gray-200 py-10 px-3 text-center">
                                        <p>
                                            Pour obtenir un prix, veuillez nous
                                            contacter par courriel en{' '}
                                            <a
                                                href={`mailto:contact@locationdesjardins.com?subject=${product?.title}&body=Bonjour,%0D%0A%0D%0AJ'aimerais avoir de l'information à propos du produit ${product?.title}.%0D%0A%0D%0A`}
                                                style={{ color: '#BC292D' }}
                                            >
                                                cliquant ici.
                                            </a>
                                        </p>
                                        <p>
                                            Ou sinon par téléphone au{' '}
                                            <a
                                                href="tel:+1-819-362-2325"
                                                style={{ color: '#BC292D' }}
                                            >
                                                819-362-2325
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ProductSheet;
